module.exports = __webpack_public_path__ + "img/parking-icon.1e981063.svg";